import { TileContext } from '../context'
import { TileProps } from '../defaults'
import { TileComponents } from './tiles'

const TileRenderer = (props: TileProps) => {
  const Component =
    TileComponents[
      `${props.tile.type.replace(
        'Tile::',
        '',
      )}Tile` as keyof typeof TileComponents
    ]

  return (
    <TileContext.Provider value={props}>
      <Component />
    </TileContext.Provider>
  )
}

export default TileRenderer
